import { StoreState } from '../../reducers';
import { connect } from 'react-redux';
import BackToPublication from '../../components/BackToPublication';
import { getMenuButtonIconSrc } from '../../utils/menuManager';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		backToPublication: {
			publicationId,
			page
		},
		galleryInfos: { config },
		driveList: { driveItems, resolutions },
		offlineManager: { thumbMap },
	} = state;
	const { icon } = ownProps;
	return {
		publicationId,
		page,
		iconSrc: getMenuButtonIconSrc(icon, driveItems, config, thumbMap, resolutions),
	};
};

export default connect(mapStateToProps)(BackToPublication);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/BackToPublication/index.tsx